export var styleAttributesList = {
  theme: true
};